"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AemComponentType = void 0;
var AemComponentType;
(function (AemComponentType) {
    AemComponentType["COLLAPSIBLE_LIST_V2"] = "platform-asadventure/components/general/collapsible-list/v2/collapsible-list";
    AemComponentType["COLLAPSIBLE_LIST_ITEM_V2"] = "platform-asadventure/components/general/collapsible-list-item/v2/collapsible-list-item";
    AemComponentType["TEXT_BLOCK_V2"] = "platform-asadventure/components/general/text-block/v2/text-block";
    AemComponentType["TEASER_V2"] = "platform-asadventure/components/general/teaser/v2/teaser";
    AemComponentType["CTA"] = "platform-asadventure/components/general/call-to-action-button";
    AemComponentType["DIVIDER"] = "platform-asadventure/components/general/divider";
    AemComponentType["VIDEO_V2"] = "platform-asadventure/components/general/video/v2/video";
    AemComponentType["LIST_ITEM"] = "platform-asadventure/components/general/list-item";
    AemComponentType["LIST_V2"] = "platform-asadventure/components/general/list/v2/list";
})(AemComponentType || (exports.AemComponentType = AemComponentType = {}));
//# sourceMappingURL=AemComponentEnums.js.map